import { render } from "./OutwardBound.vue?vue&type=template&id=6f92c1ab"
import script from "./OutwardBound.vue?vue&type=script&lang=js"
export * from "./OutwardBound.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__